<template>
  <b-modal id="modal-tutorial" dialog-class="modal-tutorial" size="custom" hide-footer hide-header :no-enforce-focus="true">
    <button type="button" class="close" aria-label="Close" @click="$bvModal.hide('modal-tutorial')">
      <span aria-hidden="true">&times;</span>
    </button>
    <img class="img-fluid" src="https://jaleko-files.s3.sa-east-1.amazonaws.com/img/agenda-modal-tutorial.svg">
    <p class="titulo">A agenda de estudos mudou!</p>
    <p class="conteudo">Agora você pode criar todos os cronogramas necessários para o seu estudo e organização, editá-los e apagá-los quando necessário - e mais, tudo aqui no Jaleko.</p>
    <div class="footer">
      <p class="d-none d-lg-block">1 de 5</p>
      <v-btn rounded class="btn primary-button proximo-modal" color="#7C56F6" @click="onBoardingNext">
        Próximo
      </v-btn>
    </div>
  </b-modal>
</template>

<script>
import './style.scss'

export default {
  name: 'Tutorial',
  data () {
    return {
      oi: null
    }
  },

  mounted () {
    this.$root.$on('bv::modal::show', () => {
      localStorage.setItem('tutorialAgenda', true)
    })
  },

  methods: {
    show: function () {
      this.$bvModal.show('modal-tutorial')
    },

    onBoardingNext: function () {
      this.$emit('onBoardingNext', 2)
    }
  }
}
</script>
